<template><p v-if="checked" role="status" class="task-feedback" :class="{ success: correct }">{{ correct ? successMessage : 'Some things need another look. You can change your choices and check again.' }}</p></template>
<script>
export default { props: { checked: Boolean, correct: Boolean, successMessage: { type: String, default: 'Well done! Everything is in the right place.' } } };
</script>
